
export const language = {
    namespaced: true,
    state: () => ({
        lang: localStorage.getItem('language') || 'nl',
        tooltips: {}
    }),
    getters: {
        getLanguage(state) {
            return state.lang
        },
        getTooltip: (state) => (field) => {
            if(!state.tooltips[state.lang]) {
                return null
            }
            return state.tooltips[state.lang][field]
        }
    },
    
    mutations: {
        SET_LANGUAGE(state, payload) {
            localStorage.setItem('language', payload)
            state.lang = payload
        },
        SET_TOOLTIPS(state, payload) {
            state.tooltips = payload
        }

    },

    actions: {
        updateLanguage({ commit }, lang) {
            commit('SET_LANGUAGE', lang)
        },

        getAllLanguges() {
            '/api/localization/list/languages'
        },
        setTooltips({ commit }, tips) {
            commit('SET_TOOLTIPS', tips)
        }
    }
}